import { createSelector } from 'reselect';

export const getApplicationState = (state) => state.applications.list;
export const getSecurity = (state) => state.security;

export const selectUser = createSelector(getSecurity, (security) => security.user);

export const selectApplications = createSelector(
    [getApplicationState],
    (applications) => applications.data
);

export const selectApplicationSearchTerm = createSelector(
    [getApplicationState],
    (applications) => applications.searchTerm
);

export const selectFilteredApplicationList = createSelector(
    getApplicationState,
    selectApplicationSearchTerm,
    (appList, searchTerm) =>
        searchTerm
            ? appList.data.filter((application) =>
                  application.name.toLowerCase().includes(searchTerm.toLowerCase())
              )
            : appList.data
);

export const selectAccountNotificationsData = (state) => state.applications.notifications.data;
